import { styled, Stack } from '../../../../base';

export const StyledEmptyStateWrapper = styled(Stack)(({ theme }) => ({
    flex: 1,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(6, 2),
    gap: theme.spacing(1),
}));
